import { render, staticRenderFns } from "./PersonnelRecordDetailCard.vue?vue&type=template&id=1c03664c"
import script from "./PersonnelRecordDetailCard.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports